export default __webpack_public_path__ + "static/media/room1.30b5f040.jpg";